module.exports = __webpack_public_path__ + "img/2-3.88466804.png";